import { Capacitor } from '@capacitor/core';
import Cookies from 'js-cookie';
import { setAppStorage, getAppStorage, deleteAppStorage } from './storage';


export const setAppCookie = async (
  key: string,
  value: any,
  getExpirationDate: (customerId?: number) => Date,
  customerId?: number,

) => {
  const platform = Capacitor.getPlatform();
  const host = window.location.hostname.startsWith('.')
    ? window.location.hostname
    : `.${window.location.hostname}`;
  const isSecure = window.location.protocol.startsWith('https');

  const expiresDate = getExpirationDate(customerId);
  

  let stringifiedValue;

  if (typeof value === 'string') {
    stringifiedValue = value;
  } else {
    stringifiedValue = JSON.stringify(value);
  } 

  if (platform === 'web' || platform === 'android') {
    await setAppStorage(key, stringifiedValue);
  } else {
    // iOS → js-cookie
    Cookies.set(key, stringifiedValue, {
      expires: expiresDate,
      secure: isSecure,
      sameSite: 'Lax',
      domain: host,
    });
  }
};

export const getAppCookie = async (key: string): Promise<any> => {
  try {
    const platform = Capacitor.getPlatform();
    let cookieData: any;

    if (platform === 'ios') {

      const raw = Cookies.get(key);
      if (!raw) return undefined;
      cookieData = JSON.parse(raw);

    } else if (platform === 'web' || platform === 'android') {

      const raw = await getAppStorage(key);
      if (raw) {

        if (typeof raw === 'string' && raw.trim() !== '') {
          try {
            cookieData = JSON.parse(raw);
          } catch (e) {
            console.warn(`Failed to parse cookie "${key}":`, e);
            cookieData = raw; // fallback to raw value if parsing fails
          }
        } else {
          cookieData = raw; // fallback to return the raw value
        }

      }

    }

    return cookieData;
  } catch (error) {
    console.error(`Failed to get cookie "${key}":`, error);
    return undefined;
  }
};


export const deleteAppCookie = async (key: string): Promise<void> => {
  const platform = Capacitor.getPlatform();
  
  if (platform === 'ios') {
    Cookies.remove(key, { path: '/' });
  } else if (platform === 'web' || platform === 'android') {
    await deleteAppStorage(key);
  }
};
